import { useServicerStore } from '../store';

export default function useUserRole() {
  const userRole = useServicerStore((state) => state.userRole);

  return {
    userRole,
    isSuperAdmin: userRole === 'superAdmin',
    isLender: userRole === 'lender',
    isBorrower: userRole === 'borrower',
  };
}
